export const VISIT_FREQUENCY_LABELS = {
    weekly: 'Semanal',
    biweekly: 'Quinzenal',
    monthly: 'Mensal',
};

export function visitFrequencyLabel(value) {
    if (!value) {
        return '—';
    }
    return VISIT_FREQUENCY_LABELS[value] || value;
}

export function formatCalendarDate(value) {
    if (!value) {
        return '—';
    }
    const raw = String(value).slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return String(value);
    }
    const [year, month, day] = raw.split('-');
    return `${day}/${month}/${year}`;
}

export function localISODate(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function itemKindLabel(value) {
    return value === 'accessory' ? 'Acessório' : 'Produto';
}

export function partnerModalityLabel(value) {
    if (value === 'consignment') return 'Consignação';
    if (value === 'repasse') return 'Repasse (Comissão)';
    if (value === 'pay_to_sell') return 'Pay to sell';
    return value || '—';
}

export function partnerStatusLabel(value) {
    if (value === 'active') return 'Ativa';
    if (value === 'paused') return 'Pausada';
    if (value === 'ended') return 'Encerrada';
    if (value === 'inactive') return 'Inativa';
    return value || '—';
}

export function partnerRetailUnitCents(item) {
    return Math.max(0, Number(item?.suggested_retail_cents) || 0);
}

/** Valor unitário que você recebe (campo do acordo). */
export function partnerRepasseFieldUnitCents(item) {
    return Math.max(0, Number(item?.consignment_repasse_cents) || 0);
}

/** Sua parte: o valor negociado no acordo. */
export function partnerMyShareUnitCents(item) {
    return partnerRepasseFieldUnitCents(item);
}

/** Parte do parceiro: varejo − a sua parte. */
export function partnerPartnerShareUnitCents(item) {
    return Math.max(0, partnerRetailUnitCents(item) - partnerRepasseFieldUnitCents(item));
}

/** @deprecated Use partnerPartnerShareUnitCents. */
export function partnerCommissionUnitCents(item) {
    return partnerPartnerShareUnitCents(item);
}

/** @deprecated Prefer partnerRetailUnitCents. */
export function partnerSaleUnitCents(item) {
    return partnerRetailUnitCents(item);
}

/** @deprecated Prefer partnerMyShareUnitCents. */
export function partnerRepasseUnitCents(item) {
    return partnerMyShareUnitCents(item);
}

export function isRepassePartnerModality(value) {
    return value === 'repasse';
}

export function isConsignmentPartnerModality(value) {
    return value === 'consignment';
}

export function isVisitManagedPartnerModality(value) {
    return value === 'consignment' || value === 'repasse';
}

export function visitStatusLabel(value) {
    if (value === 'done') return 'Concluída';
    if (value === 'skipped') return 'Pulado';
    return 'Agendada';
}
